import { IDEX_CONTRACTS } from '../index';

import { tokensList as listIdexswapTokens } from './idexswapTokens';
import { tokensList as listPancakeswap } from './pancakeswap';

const tokensList = IDEX_CONTRACTS ? listIdexswapTokens : listPancakeswap;

export default tokensList;
